import { render, staticRenderFns } from "./DxGridWithSearch.vue?vue&type=template&id=437a52cd&scoped=true&"
import script from "./DxGridWithSearch.vue?vue&type=script&lang=js&"
export * from "./DxGridWithSearch.vue?vue&type=script&lang=js&"
import style0 from "./DxGridWithSearch.vue?vue&type=style&index=0&id=437a52cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437a52cd",
  null
  
)

export default component.exports